module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "video-background"
  }, [_c('div', {
    staticClass: "video-foreground"
  }, [_c('youtube', {
    attrs: {
      "id": "video",
      "videoId": _vm.video.videoId,
      "player-width": "100%",
      "player-height": "100%",
      "player-vars": {
        start: _vm.video.params.start,
        end: _vm.video.params.end,
        autoplay: 1,
        disabled: 1,
        showinfo: 0,
        modestbranding: 1,
        playlist: _vm.video.videoId,
        loop: 1,
        controls: 0
      }
    },
    on: {
      "ready": _vm.ready
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e33ae52"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/player/backgroundvideo.vue
// module id = 277
// module chunks = 1